var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.732 12.11c2.255-2.532 5.816-4.165 8.94-4.109a.335.335 0 0 1 .326.326c.072 3.12-1.574 6.68-4.109 8.94a8.44 8.44 0 0 1-2.447 5.776.38.38 0 0 1-.258.107.3.3 0 0 1-.096-.015c-.119-.04-.218-.132-.236-.257l-.367-2.57-.356.318a.33.33 0 0 1-.458-.013l-4.284-4.285a.333.333 0 0 1-.014-.458l.318-.355-2.57-.368a.334.334 0 0 1-.186-.567 8.46 8.46 0 0 1 5.797-2.47m4.69 2.134a1.669 1.669 0 0 0 1.179-2.845 1.67 1.67 0 0 0-2.359 0 1.67 1.67 0 0 0 0 2.357c.325.325.752.488 1.18.488M8.013 23.57c.11-.365 1.089-3.588 1.802-4.301a2.063 2.063 0 0 1 2.914 0c.803.803.803 2.11 0 2.914-.713.713-3.936 1.693-4.3 1.802a.333.333 0 0 1-.415-.415",
  clipRule: "evenodd"
})));
export default SvgRocket;